import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from '../api/http-utils.service';
import { Observable, catchError, map, mergeMap, of } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { environment } from '../../../environment/environment';
import { OverviewCounters, OverviewCountersData } from '../../model/overview/counters';
import { OverviewTraffic, OverviewTrafficData } from '../../model/overview/traffic';
import { UsersDistribution, UsersDistributionData } from '../../model/overview/users';
import { LoginUsers, LoginUsersData } from '../../model/overview/login';
import { OverviewTrafficAverage, OverviewTrafficAverageData } from '../../model/overview/average_traffic';
import { Paging } from '../../model/paging/paging';
import { Invitation, InvitationData } from '../../model/invitations/invitation';

@Injectable({
	providedIn: 'root'
})

export class InvitationsService_Mock {
	private _url: string = `${environment.baseAPI}/invitations`;
	constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }
	GETInvitationsList(paging: Paging): Observable<any> {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"data": {
				"count": 15,
				"data": [
					{
						"id": "1a2b3c4d5e6f7g8h9i0j",
						"email": "user1@example.com",
						"created_at": 1710000000000,
						"type": "invite",
						"status": "pending"
					},
					{
						"id": "2b3c4d5e6f7g8h9i0j1a",
						"email": "user2@example.com",
						"created_at": 1710001000000,
						"type": "invite",
						"status": "accepted"
					},
					{
						"id": "3c4d5e6f7g8h9i0j1a2b",
						"email": "user3@example.com",
						"created_at": 1710002000000,
						"type": "invite",
						"status": "expired"
					},
					{
						"id": "4d5e6f7g8h9i0j1a2b3c",
						"email": "user4@example.com",
						"created_at": 1710003000000,
						"type": "invite",
						"status": "pending"
					},
					{
						"id": "5e6f7g8h9i0j1a2b3c4d",
						"email": "user5@example.com",
						"created_at": 1710004000000,
						"type": "invite",
						"status": "accepted"
					},
					{
						"id": "6f7g8h9i0j1a2b3c4d5e",
						"email": "user6@example.com",
						"created_at": 1710005000000,
						"type": "invite",
						"status": "expired"
					},
					{
						"id": "7g8h9i0j1a2b3c4d5e6f",
						"email": "user7@example.com",
						"created_at": 1710006000000,
						"type": "invite",
						"status": "pending"
					},
					{
						"id": "8h9i0j1a2b3c4d5e6f7g",
						"email": "user8@example.com",
						"created_at": 1710007000000,
						"type": "invite",
						"status": "accepted"
					},
					{
						"id": "9i0j1a2b3c4d5e6f7g8h",
						"email": "user9@example.com",
						"created_at": 1710008000000,
						"type": "invite",
						"status": "expired"
					},
					{
						"id": "0j1a2b3c4d5e6f7g8h9i",
						"email": "user10@example.com",
						"created_at": 1710009000000,
						"type": "invite",
						"status": "pending"
					},
					{
						"id": "a1b2c3d4e5f6g7h8i9j0",
						"email": "user11@example.com",
						"created_at": 1710010000000,
						"type": "invite",
						"status": "accepted"
					},
					{
						"id": "b2c3d4e5f6g7h8i9j0a1",
						"email": "user12@example.com",
						"created_at": 1710011000000,
						"type": "invite",
						"status": "expired"
					},
					{
						"id": "c3d4e5f6g7h8i9j0a1b2",
						"email": "user13@example.com",
						"created_at": 1710012000000,
						"type": "invite",
						"status": "pending"
					},
					{
						"id": "d4e5f6g7h8i9j0a1b2c3",
						"email": "user14@example.com",
						"created_at": 1710013000000,
						"type": "invite",
						"status": "accepted"
					},
					{
						"id": "e5f6g7h8i9j0a1b2c3d4",
						"email": "user15@example.com",
						"created_at": 1710014000000,
						"type": "invite",
						"status": "expired"
					}
				]
			},
			"elapsed": 100
		};
		const jsonConvert: JsonConvert = new JsonConvert();
		const response: OverviewCountersData = jsonConvert.deserializeObject(mockData, OverviewCountersData);
		return of(mockData);
	}

	GETInvitation(id: string): Observable<any> {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"data": {
				"id": "wqwui21223jd",
				"email": "user@example.com",
				"first_name": "John",
				"last_name": "Doe",
				"phone_number": "+1234567890",
				"location": "Rome",
				"policy": "Default Policy",
				"type": "invite",
				"valid_from": 1710004000000,
				"valid_to": 1712606000000,
				"max_devices": 3,
				"notes": "Test invitation",
				"user_type": "guest",
				"status": "accepted",
				"sent_at": 1710004100000
			}
		};
		const jsonConvert: JsonConvert = new JsonConvert();
		const invitation: InvitationData = jsonConvert.deserializeObject(mockData, InvitationData);
		return of(invitation);
	}
}